// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:479px){.listTitle[data-v-33f17b3e]{font-size:var(--font-size-big)}}", ""]);
// Exports
module.exports = exports;
